<div class="ui menu" style="border-radius: 0">
  <a class="item" routerLink="/home" routerLinkActive="active">
    <img src="/assets/logo.svg" alt="FIT Logo" height="100%">
    Home
  </a>
  <a class="item" routerLink="/newsletters" routerLinkActive="active" i18n="@@newsletters">Newsletter</a>
  @if (userRoles.includes(clientRoles.ACCESS_CATALOG)) {
    <a class="item" routerLink="/topics" routerLinkActive="active" i18n="@@categories">Kategorien</a>
    <a class="item" routerLink="/articles" routerLinkActive="active" i18n="@@articles">Artikel</a>
  }
  @if (userRoles.includes(clientRoles.ACCESS_PUBLISH)) {
    <div class="ui pointing dropdown link item" suiDropdown routerLinkActive="active">
      <span class="text" i18n="@@navbar-publish">Publizieren</span>
      <i class="dropdown icon"></i>
      <div class="menu" suiDropdownMenu>
        <a class="item" routerLink="/author/articles" i18n="@@articles">Artikel</a>
        <a class="item" routerLink="/author/internalMessages" i18n="@@internal-messages">Interne Mitteilungen</a>
      </div>
    </div>
  }
  <div class="right menu">
    @if (userRoles.includes(clientRoles.ACCESS_SUBADMIN)) {
      <div class="ui pointing dropdown link item" suiDropdown routerLinkActive="active">
        <span class="text" i18n="@@navbar-administration">Administration</span>
        <i class="dropdown icon"></i>
        <div class="menu" suiDropdownMenu>
          <div class="item" routerLink="/subadmin/institution" i18n="@@navbar-institutions">
            Institution verwalten
          </div>
          <div class="item" routerLink="/subadmin/articles" i18n="@@navbar-articles">
            Artikel verwalten
          </div>
          <div class="item" routerLink="/subadmin/internalMessages" i18n="@@navbar-internal-messages">
            Interne Mitteilungen verwalten
          </div>
        </div>
      </div>
      <a class="item" routerLink="/statistics/subadmin" routerLinkActive="active" i18n="@@navbar-own-statistics">
        Eigene Statistiken
      </a>
    }
    @if (userRoles.includes(clientRoles.ACCESS_ADMIN)) {
      <a class="item" routerLink="/statistics/admin" routerLinkActive="active" i18n="@@navbar-admin-statistics">
        Admin-Statistiken
      </a>
      <div class="ui pointing dropdown link item" suiDropdown routerLinkActive="active">
        <span class="text">Adminbereich</span>
        <i class="dropdown icon"></i>
        <div class="menu" suiDropdownMenu>
          <a class="item" routerLink="/admin/topics">Kategorien</a>
          <a class="item" routerLink="/admin/subjectareas">Fachrichtungen</a>
          <a class="item" routerLink="/admin/institutions">Institutionen</a>
          <a class="item" routerLink="/admin/articles">Artikel</a>
          <a class="item" routerLink="/admin/users">Nutzer</a>
          <a class="item" routerLink="/admin/contacts">Kontaktpersonen</a>
          <a class="item" routerLink="/admin/mailing">Admin-Mail</a>
        </div>
      </div>
    }
    @if (userRoles.includes(clientRoles.ACCESS_SETTINGS)) {
      <a class="item" [routerLink]="['/settings/profile']" routerLinkActive="active"
         i18n="@@navbar-settings">Einstellungen</a>
    }
    <div class="ui pointing dropdown link item" suiDropdown>
      <span class="text" suiPopup popupText="Sprache/Language" popupPlacement="bottom">
        <i class="globe icon"></i>
      </span>
      <i class="dropdown icon"></i>
      <div class="menu" suiDropdownMenu>
        @for (locale of LOCALES; track locale.id) {
          <a class="item" [href]="locale.baseUrl + '/home'">{{ locale.label }}</a>
        }
      </div>
    </div>
    <a class="item" [routerLink]="['/contact']" routerLinkActive="active"
       i18n="@@navbar-contact">Kontakt</a>
    <div class="item">
      @if (userRoles.length) {
        <button id="logout-button" class="ui primary button" (click)="keycloakService.logout()">Logout</button>
      } @else {
        <button id="login-button" class="ui primary button" (click)="keycloakService.login()">Login</button>
      }
    </div>
  </div>
</div>
